export type ErrorMessages = Record<string, any>;

export const ERROR_MESSAGE: ErrorMessages = {
  required: () => 'Pole wymagane',
  minlength: () => 'Za mała wartość',
  min: () => 'Za mała wartość',
  max: () => 'Za duża wartość',
  peselOrDocumentRequired: () =>
    'Należy podać PESEL lub rodzaj i numer dokumentu',
  peselPlecInvalid: () => 'Numer PESEL i płeć nie zgadzają się',
  stanCywilnyPlecInvalid: () =>
    'Wybrany stan cywilny nie jest zgodny z podaną płcią',
  invalidPesel: () => 'Niepoprawny numer PESEL',
  maxlength: () => 'Przekroczono dozwoloną liczbę znaków',
  doNotBeginWithWhitespace: () => 'Niepoprawna wartość',
  atLeastOneInstitutionRequired: () =>
    'Należy wybrać przynajmniej jedną instytucję',
  pattern: () => 'Niepoprawna wartość',
  default: () => 'Nieprawidłowa wartość',
  invalidBankAccountNumber: () => 'Nieprawidłowy numer konta',
  invalidNumerDokumentuTozsamosci: () =>
    'Nieprawidłowy numer dowodu osobistego',
  incorrectPattern: () => 'Pole ma niepoprawny format',
  providePhoneNumber: () => 'Podaj numer telefonu',
  incorrectPhoneNumber: () => 'Niepoprawny numer telefonu',
  invalidEmail: () => 'Adres e-mail jest nieprawidłowy',
  invalidImieNazwisko: () => 'Nieprawidłowy format',
  dateInPast: () => 'Data nie może być z przeszłości',
  dateInFuture: () => 'Data nie może być z przyszłości',
  dateRangeInvalid: () => 'Nieprawidłowy zakres dat',
  recipientSearchMinLength: () => 'Wprowadź co najmniej 3 znaki',
  recipientSearchReasonRequired: () => 'Wybierz powód wyszukiwania',
  invalidRecipientSearchCriteria: () =>
    'Podaj PESEL albo imię i nazwisko oraz jeden dodatkowy parametr: numer dokumentu, datę urodzenia, adres e-mail lub miejscowość',
  invalidDayForMonth: () => 'Nieprawidłowa liczba dni dla wybranego miesiąca',
  userSearchMinLength: () => 'Wprowadź co najmniej 3 znaki',
  userSearchReasonRequired: () => 'Wybierz powód wyszukiwania',
  invalidUserSearchCriteria: () =>
    'Podaj PESEL albo imię i nazwisko oraz jeden dodatkowy parametr: numer dokumentu, datę urodzenia, adres e-mail lub miejscowość',
};
